import React, { useState } from 'react';
import SwiperCore, { Pagination } from 'swiper';
import 'swiper/modules/pagination/pagination.scss';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import Form from './Form';
import FormData from './FormData';
import FormDataFr from './FormDataFr';
import FormModal from './FormModal';
import { makeStyles } from '@material-ui/core/styles';
import './FormSection.css';
import { Container } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
const useStyles = makeStyles({
  firstdiv: {
    paddingBottom: '4px',
    ['@media (max-width:768px)']: {
      padding: '8px 0px',
    },
    ['@media (max-width:425px)']: {
      marginTop: '15px',
    },
  },
  rowdiv2: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginRight: '-15px',
    marginLeft: '-15px',
  },
  formslider: {
    display: 'none',
    ['@media screen and (max-width: 770px)']: {
      display: 'block',
    },
  },
  formregular: {
    ['@media screen and (max-width: 770px)']: {
      display: 'none',
    },
  },
});
function FormSection(props) {
  const classes = useStyles();
  SwiperCore.use([Pagination]);
  const [showFormModal, setFormModal] = useState(false);
  const [modalData, setModalData] = useState();

  function ModalData(data) {
    setModalData(data);
  }

  function handleFormModal(state) {
    setFormModal(state);
  }
  const { t } = useTranslation();
  let Data;
  if (props.selectedLang === 'fr') {
    Data = FormDataFr;
  } else {
    Data = FormData;
  }
  return (
    <>
      <div className={`formSection ${classes.firstdiv}`} id="formSection">
        <Container fixed className=" form-container">
          <div className="section-title" style={{ marginBottom: '16px' }}>
            <h2>{t('sections-Formsection-FormSection-Header')}</h2>
            <p>{t('sections-Formsection-FormSection-para')}</p>
          </div>
          <div>
            <p
              className=" calculator-heading-description"
              style={{ margin: '0px' }}
            >
              {t('sections-Formsection-FormSection-Desc')}
            </p>
          </div>
          <div
            className={`${classes.rowdiv2} ${classes.formslider} forms  form-slider `}
            // className="row forms justify-content-center form-slider"
          >
            {
              <Swiper
                pagination={{
                  dynamicBullets: true,
                  clickable: true,
                  // bulletClass: "mt-2",
                }}
                // slidesPerView={1}
              >
                {Data.map((form, i) => {
                  return (
                    <SwiperSlide key={i}>
                      <Form
                        data={form}
                        setModalData={ModalData}
                        handleFormModal={handleFormModal}
                      />
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            }
          </div>
          <div
            className={`${classes.rowdiv2} ${classes.formregular} forms form-regular`}
            // className="row forms justify-content-center form-regular "
          >
            {Data.map((form, i) => (
              <Form
                key={i}
                data={form}
                setModalData={ModalData}
                handleFormModal={handleFormModal}
              />
            ))}
          </div>
        </Container>
      </div>
      {showFormModal ? (
        <FormModal
          data={modalData}
          show={showFormModal}
          handleModal={handleFormModal}
        />
      ) : (
        ''
      )}
    </>
  );
}

export default FormSection;
